import { createAppSlice } from "../../app/createAppSlice"
import { createEntityAdapter, isAnyOf } from '@reduxjs/toolkit'
import { startAppListening } from "../../app/listenerMiddleware"
import { getUserNotifications, updateUserNotification } from "./notificationsFunctionsAPI"
import { numberUnClearedNotificationsChanged, numberUnreadNotificationsChanged, selectCurrentUserApiToken } from "../currentUser/currentUserSlice"

const fetchNotificationsAPI = async (apiToken) => {
    let response = await getUserNotifications(apiToken);
    if (response?.success && response.notifications) {
        let notificationCollection = response.notifications;
        notificationCollection.map(item => {
            item.id = item._id;
            item.timeString = (new Date(item.time)).toLocaleString(undefined,    //"en-US"
                { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' } //weekday: 'long', month: 'long'
            );
            return item;
        });
        return notificationCollection;
    }
    return [];
}

//entity: { id: "68710a8bed09b4f5828faa80",
//  classifier: "resource-updated",
// message: "Resource title (FOI 27270) was updated.",
//  target: "27270",
//  time: "2025-07-21T10:16:48.666Z",
//  timeString: "Mon, Jul 21, 2025, 6:16 AM",
//  uncleared: true,
//   unread: false,
//   userid: 16
//        }

//key uses: to provide notifications regarding updates to Resources
const notificationsAdapter = createEntityAdapter({
    selectId: (notification) => notification._id,
});

const initialState = notificationsAdapter.getInitialState({
    status: 'idle',
    error: null
});

const notificationsSlice = createAppSlice({
    name: "notifications",
    initialState,
    reducers: create => ({
        notificationAdded: create.preparedReducer(
            (notificationBody) => {
                return {
                    payload: {
                        id: notificationBody.id,
                        classifier: notificationBody.classifier,
                        message: notificationBody.message,
                        target: notificationBody.target,
                        time: notificationBody.time,
                        timeString: notificationBody.timeString,
                        uncleared: notificationBody.uncleared,
                        unread: notificationBody.unread,
                        userid: notificationBody.userid
                    }
                }
            },
            notificationsAdapter.addOne
        ),
        notificationUpdated: create.reducer((state, action) => {
            const { id, uncleared, unread } = action.payload;
            notificationsAdapter.updateOne(state,
                { id, changes: { uncleared, unread } })
        }),
        fetchNotifications: create.asyncThunk(
            async (_, { getState }) => {
                const state = getState();
                const apiToken = selectCurrentUserApiToken(state);
                const notificationsCollection = await fetchNotificationsAPI(apiToken);
                return notificationsCollection;
            },
            {
                /*
                options: {
                    condition(arg, thunkApi) {
                        const { notifications } = thunkApi.getState()
                        if (notifications.status !== 'idle') {
                            return false
                        }
                    }
                },
                */
                pending: state => {
                    state.status = "loading"
                },
                fulfilled: (state, action) => {
                    state.status = "succeeded"
                    notificationsAdapter.setAll(state, action.payload)
                },
                rejected: (state, action) => {
                    state.status = "failed"
                    state.error = action.error.message ?? "Unknown Error"
                },
            },
        ),
    }),
    selectors: {
        selectNotificationsStatus: notifications => notifications.status,
        selectNotificationsError: notifications => notifications.error
    },
})

export const { notificationAdded, notificationUpdated, fetchNotifications } = notificationsSlice.actions

export const { selectNotificationsStatus, selectNotificationsError } = notificationsSlice.selectors

export const {
    selectAll: selectAllNotifications,
    selectById: selectNotificationById
} = notificationsAdapter.getSelectors(state => state.notifications);

export const addNotificationsListeners = () => {
    startAppListening({
        matcher: isAnyOf(notificationAdded, notificationUpdated),
        effect: async (action, listenerApi) => {
            const { dispatch } = listenerApi;
            const state = listenerApi.getState();
            const apiToken = selectCurrentUserApiToken(state);
            console.log("notifications listener was triggered")
            try {
                const updatedNotification = action.payload;
                let response = await updateUserNotification(updatedNotification, apiToken);
                if (response?.success && (response.numberUnread || response.numberUnread === 0)) {
                    let numberUncleared = response.numberUncleared;
                    let numberUnread = response.numberUnread;
                    dispatch(numberUnreadNotificationsChanged(numberUnread));
                    dispatch(numberUnClearedNotificationsChanged(numberUncleared));
                }
            } catch (err) {
                console.log("FAILURE of updateNotifications: ", err)
            }
        }
    })
}

export default notificationsSlice
